import * as React from "react";
import { RiskFactor } from "@/common/js/constant";
import { highlightMarkerSafe } from "@/utils/highlight";
import { trackEvent } from "@/utils/omega";
import switchChevronIcon from "../assets/images/switch-chevron.svg";
import switchCloseIcon from "../assets/images/switch-close.svg";
import type { RiskVerifyUiVariant } from "../types";

// 页面参数
type SwitchFactorProps = {
  detail: SwitchVerifyDetail;
  uiVariant?: RiskVerifyUiVariant;
  minHeight?: number;
  onSelect: (factor: RiskFactor) => void;
  onCancel?: (cancelByUser: boolean | undefined) => void;
};

export default function SwitchFactor(props: SwitchFactorProps) {
  const isUno = props.uiVariant === "uno";
  // 用户取消
  const handleCancel = (cancelByUser?: boolean) => {
    if (cancelByUser) {
      // 上报埋点
      trackEvent("fin_sofi_verification_captcha_popup_ck", {
        button_name: "off",
      });
    }
    props.onCancel && props.onCancel(cancelByUser);
  };
  //
  const handleSelect = (factor: RiskFactor) => {
    // 上报埋点
    trackEvent("fin_sofi_verification_captcha_popup_ck", {
      button_name: factor,
    });
    props.onSelect(factor);
  };

  // 高亮内容
  const highlightHtml = (remark: string) => highlightMarkerSafe(remark);

  // did mount
  React.useEffect(() => {
    // 设置pub page
    // setCommonAttrs({ pub_page: "fin_sofi_verification_captcha_popup"});
    // 上报埋点
    trackEvent("fin_sofi_verification_captcha_popup_sw", {});
  }, []);

  return (
    <div
      className={isUno ? "switch-factor switch-factor-uno" : "switch-factor"}
      style={!isUno && props.minHeight ? { minHeight: `${props.minHeight}px` } : undefined}
      role={isUno ? "dialog" : undefined}
      aria-modal={isUno ? true : undefined}
      aria-labelledby={isUno ? "switch-factor-uno-title" : undefined}
    >
      {isUno ? (
        <>
          <button
            className="switch-factor-uno-close"
            type="button"
            aria-label="Close"
            onClick={handleCancel.bind(null, true)}
          >
            <img src={switchCloseIcon} alt="" />
          </button>
          <h1 id="switch-factor-uno-title">{props.detail.switchVerifyDetail?.title}</h1>
          <div className="switch-factor-content switch-factor-uno-content">
            <div className="switch-factor-uno-card">
              {props.detail.switchVerifyDetail?.switchVerifyList.map((item, index, list) => {
                return (
                  <React.Fragment key={item.name || index}>
                    <button
                      className="switch-factor-uno-item"
                      type="button"
                      onClick={handleSelect.bind(null, item.name)}
                    >
                      <span className="switch-factor-uno-icon" aria-hidden="true">
                        {item.buttonImg ? <img src={item.buttonImg} alt="" /> : null}
                      </span>
                      <span className="switch-factor-uno-copy">
                        <span className="switch-factor-uno-item-title">{item.buttonTitle}</span>
                        <span
                          className="switch-factor-uno-item-desc"
                          dangerouslySetInnerHTML={{
                            __html: highlightMarkerSafe(item.title, "#1A7FEF"),
                          }}
                        />
                      </span>
                      <img
                        className="switch-factor-uno-chevron"
                        src={switchChevronIcon}
                        alt=""
                        aria-hidden="true"
                      />
                    </button>
                    {index < list.length - 1 ? (
                      <div className="switch-factor-uno-divider" aria-hidden="true" />
                    ) : null}
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        </>
      ) : (
        <>
          <h1>{props.detail.switchVerifyDetail?.title}</h1>
          <div className="switch-factor-content">
            {props.detail.switchVerifyDetail?.switchVerifyList.map((item, index) => {
              return (
                <div className="switch-factor-list" key={index}>
                  <p dangerouslySetInnerHTML={{ __html: highlightHtml(item.title) }}></p>
                  <div className="btn-group">
                    <div
                      className={`btn-confirm`}
                      onClick={handleSelect.bind(null, item.name)}
                      style={{ backgroundColor: item.bgColor, color: item.buttonTitleColor }}
                    >
                      {item.buttonImg ? (
                        <img alt="" className="btn-icon" src={`${item.buttonImg}`} />
                      ) : null}
                      {item.buttonTitle}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <span className="btn-close" onClick={handleCancel.bind(null, true)}></span>
        </>
      )}
    </div>
  );
}
